import { Alert, Box, Button, Grid } from '@mui/material'
import InputTextFieldUI from 'src/components/UI/inputTextField/inputTextField'
import { useForm } from 'react-hook-form'
import { IObject } from 'src/models/interfaces'
import { FC, useState } from 'react'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import SubmitDialogAction from 'src/components/SubmitDialogAction/submitDialogAction'
import { IResult } from './getConfirmationCode'
import { toast } from 'react-toastify'
import { AccountServices } from 'src/services/Account'

interface IProps {
  setStep: () => void
  userInfo: IResult | undefined
  onClose: () => void
}

const SetNewPassword: FC<IProps> = ({ setStep, userInfo, onClose }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { resetPassword } = AccountServices()

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  const onSubmit = async (values: IObject) => {
    try {
      setLoading(true)

      await resetPassword({
        confirmCode: values.confirmCode,
        newPassword: values.newPassword,
        reTypeNewPassword: values.reTypeNewPassword,
        username: userInfo!.username,
      })

      reset()
      onClose()
      toast.success('کلمه عبور با موفقیت تغییر کرد')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Alert severity="success">
        کد تایید با موفقیت به شماره <span dir="ltr">{userInfo?.message}</span> ارسال گردید
      </Alert>

      <Grid xs={12} md={12} paddingTop={2}>
        <InputTextFieldUI
          labelText="کلمه عبور جدید "
          name="newPassword"
          register={register}
          validation={{ required: true }}
          error={!!errors.newPassword}
          fullWidth
          type="password"
        />
      </Grid>

      <Grid xs={12} md={12} paddingTop={2}>
        <InputTextFieldUI
          labelText=" تکرار کلمه عبور "
          name="reTypeNewPassword"
          register={register}
          validation={{ required: true }}
          error={!!errors.reTypeNewPassword}
          fullWidth
          type="password"
        />
      </Grid>

      <Grid xs={12} md={12} paddingTop={2}>
        <InputTextFieldUI
          labelText="کد تایید"
          name="confirmCode"
          register={register}
          validation={{ required: true }}
          error={!!errors.confirmCode}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} my={2}>
        <SubmitDialogAction onClose={onClose} onSubmit={handleSubmit(onSubmit)} loading={loading} />
      </Grid>

      <Grid item xs={12} my={2} style={{ position: 'absolute', bottom: 10, right: 10 }}>
        <Button onClick={() => setStep()} sx={{ fontSize: '0.8rem' }}>
          <KeyboardArrowRightIcon />
          <span>بازگشت به مرحله قبل</span>
        </Button>
      </Grid>
    </>
  )
}

export default SetNewPassword
